import type { BrowserConfig, EnrichmentPlugin, Event } from '@amplitude/analytics-types';

// Module-level state. The Amplitude SDK is itself a singleton (process-wide);
// a module-level variable matches that lifecycle and is simpler than wiring
// Redux through the plugin's synchronous `execute()` path. Set via
// `setShouldInitAmplitudeForPlugin` from `AmplitudeProvider` when the
// `experimentEligibility.shouldInitAmplitude` value resolves (FR-16 / RD-5).
let shouldInitAmplitudeForPlugin: boolean | null = null;

export class ShouldInitAmplitudePlugin implements EnrichmentPlugin {
    name = 'should-init-amplitude-plugin';

    type = 'enrichment' as const;

    // eslint-disable-next-line @typescript-eslint/no-unused-vars, class-methods-use-this
    async setup(config: BrowserConfig): Promise<void> {
        return undefined;
    }

    // eslint-disable-next-line class-methods-use-this
    async execute(event: Event): Promise<Event | null> {
        if (shouldInitAmplitudeForPlugin === false) {
            return null;
        }

        return event;
    }
}

// Test-only helper. Resets the module-level state back to `null` so tests do
// not leak state across cases. Not called from application code. The name has
// no leading underscore: this codebase does not use the underscore convention
// for test helpers (spec §10 implementation hints).
export function resetForTesting(): void {
    shouldInitAmplitudeForPlugin = null;
}

export function setShouldInitAmplitudeForPlugin(value: boolean | null): void {
    shouldInitAmplitudeForPlugin = value;
}
